var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70119 0.738349C7.88892 0.644509 8.10979 0.644509 8.29752 0.738349L14.9642 4.07168C15.19 4.18461 15.3327 4.41546 15.3327 4.66797C15.3327 4.92048 15.19 5.15133 14.9642 5.26426L8.29752 8.59757C8.10979 8.69144 7.88892 8.69144 7.70119 8.59757L1.03454 5.26426C0.808689 5.15133 0.666016 4.92048 0.666016 4.66797C0.666016 4.41546 0.808689 4.18461 1.03454 4.07168L7.70119 0.738349ZM2.8234 4.66797L7.99932 7.25597L13.1753 4.66797L7.99932 2.07999L2.8234 4.66797Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.736542 11.0367C0.901202 10.7073 1.30165 10.5739 1.63097 10.7385L7.99948 13.9227L14.368 10.7385C14.6973 10.5739 15.0978 10.7073 15.2624 11.0367C15.4271 11.3659 15.2936 11.7664 14.9643 11.9311L8.29762 15.2644C8.10995 15.3583 7.88902 15.3583 7.70135 15.2644L1.03469 11.9311C0.705369 11.7664 0.571884 11.3659 0.736542 11.0367Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63097 7.40252C1.30165 7.23792 0.901202 7.37139 0.736542 7.70072C0.571884 8.02999 0.705369 8.43046 1.03469 8.59512L7.70135 11.9285C7.88902 12.0223 8.10995 12.0223 8.29762 11.9285L14.9643 8.59512C15.2936 8.43046 15.4271 8.02999 15.2624 7.70072C15.0978 7.37139 14.6973 7.23792 14.368 7.40252L7.99948 10.5868L1.63097 7.40252Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.3bca44388cf66f0fe42bef2f6f1c7dd4.svg";
export { ForwardRef as ReactComponent };